import { Provider } from '@angular/core';

import {
	ContentsRepository,
	ContentUploadService,
	FoldersRepository,
	ParserTextRepository,
	SignedCookiesRepository,
} from '@efficiently/client-api-content';

import { ContentsGqlRepository } from './repositories/contents-gql.repository';
import { FoldersGqlRepository } from './repositories/folders-gql.repository';
import { ParserTextGqlRepository } from './repositories/parser-text-gql.repository';
import { SignedCookiesGqlRepository } from './repositories/signed-cookies-gql.repository';
import { DefaultContentUploadService } from './services/default-content-upload.service';

export const contentProviders: Provider[] = [
	{ provide: ContentsRepository, useClass: ContentsGqlRepository },
	{ provide: FoldersRepository, useClass: FoldersGqlRepository },
	{ provide: ParserTextRepository, useClass: ParserTextGqlRepository },
	{ provide: SignedCookiesRepository, useClass: SignedCookiesGqlRepository },
	{ provide: ContentUploadService, useClass: DefaultContentUploadService },
];
